import { isNil } from 'lodash';
import React, { useEffect } from 'react';
import CableStatusComponent from './CableStatusComponent';
import OnlineStatusComponent from './OnlineStatusComponent';
import SessionStatusComponent from './SessionStatusComponent';
import { StateColumnInner } from './styles';

function CurrentlyComponent(props) {
  const {
    chargerId,
    stateChargerId,
    snapshot: {
      onlineStatus = 'offline',
      onlineStatusAt,
      cableStatus = 'disconnected',
      cableStatusAt,
      session,
    } = {},
    load,
    demo,
    snapshotLoading,
    resetChargerTelemetryState,
    updateInterval,
  } = props;

  useEffect(() => {
    if (isNil(stateChargerId) || stateChargerId !== chargerId) {
      resetChargerTelemetryState();
      load();
    }
    if (!demo) {
      const interval = setInterval(load, updateInterval * 1000);

      return () => clearInterval(interval);
    }
  }, []);

  return (
    <StateColumnInner>
      <OnlineStatusComponent
        status={onlineStatus}
        statusAt={onlineStatusAt}
        snapshotLoading={snapshotLoading}
      />
      <CableStatusComponent
        status={cableStatus}
        statusAt={cableStatusAt}
      />
      <SessionStatusComponent values={session} />
    </StateColumnInner>
  );
}

export default CurrentlyComponent;
